import React from "react";
import { Container } from "./styles";

function Public ({children}){

    return(
        <Container>
        {children}
        </Container>
    )
}
export default Public;